export default __webpack_public_path__ + "static/media/OpenSea_NFT_Listing_image.13fd4b71.png";